import * as React from 'react';
import './Title.css';
import { ClassNames } from '../../_helpers/ClassNames';

export type TitleProps = { title: string, modifier?: string };
const LETTER_PER_SECOND = 1.5;
export const Title: React.SFC<TitleProps> = (props) => {
    // speed = 
    const animationTime = props.title.length / LETTER_PER_SECOND;
    return (
        <div
            className={ClassNames("title", "", props.modifier)}
            style={{ animationDuration: `${animationTime.toFixed(2)}s` }}
        >
            <h2 className={ClassNames('title', 'text')}>{props.title}</h2>
            <h2 className={ClassNames('title', 'text')}>{props.title}</h2>
            <h2 className={ClassNames('title', 'text')}>{props.title}</h2>
            <h2 className={ClassNames('title', 'text')}>{props.title}</h2>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/Components/Title/Title.tsx